export const STEPS = {
  INTRO: 'intro',
  CATEGORIES: 'categories',
  QUESTIONS: 'questions',
  OFFER: 'offer',
  NO_OFFER: 'no_offer',
} as const

export const SWAP_ERROR_MESSAGE = {
  GET_CATEGORIES: '[BUYBACK][SWAP] Error getting questions API (categories)',
  GET_QUESTIONS: '[BUYBACK][SWAP] Error getting questions API',
  POST_QUESTIONS: '[BUYBACK][SWAP] Error posting questions API',
  GET_OFFER: '[BUYBACK][SWAP] Error getting offer',
  ADD_SWAP: '[BUYBACK][SWAP] Error adding buyback to cart',
}

export const STATUS_CODE_NO_OFFER = 204
